/* import __COLOCATED_TEMPLATE__ from './send-device-code-modal.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { equal, not, notEmpty, readOnly, filterBy } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { isPhone } from '@square/dashboard-utilities/utils/validations/validations';
import { isPresent } from '@ember/utils';
import { validator, buildValidations } from 'ember-cp-validations';
import Enum from '@square/dashboard-utilities/utils/enum';
import { escapeRegExp } from '@square/dashboard-utilities/utils/string';
import fullName from '@dashboard/i18n/utils/full-name';

/**
 ## DevicesSendDeviceCodeModal

 If the user hasSearchableOptions (can manage employees at the location), then the component uses
 the searchable field input with selectedEmailOption and selectedPhoneOption.

 Otherwise, the component uses a regular input with emailValue and phoneValue.

 this.email and this.phone are computed based on hasSearchableOptions. They are the
 computed properties that we actually send up and validate against.

  ### Parameters
  * @param {Action} sendDeviceCode - action to send when sending device code
  * @param {String} description - description to display in the modal
  * @param {Array<Employee>} employees - list of employees to suggest

  Sass dependencies at: `/dashboard/lib/01-dashboard-shared/addon/styles/dashboard/components/devices/_send-device-code-modal.scss`
*/
const OPTIONS = new Enum('EMAIL', 'PHONE');
const Validations = buildValidations({
  email: validator('format', {
    type: 'email',
    disabled: not('model.shouldSendEmail'),
    message() {
      return this.model.i18n.t('business.devices.deviceCodeRedesign.sendDeviceCodeModal.emailError');
    }
  }),
  phone: validator('inline', {
    type: 'phone',
    disabled: not('model.shouldSendPhone'),
    validate() {
      if (!isPhone(this.model.phone, this.model.userInfo.countryCode)) {
        return this.model.i18n.t('business.devices.deviceCode.errors.invalidPhone');
      }
      return true;
    }
  })
});
function filterOptionsBy(collection, filter) {
  const searchRegex = new RegExp(escapeRegExp(filter), 'i');
  return collection.filter(({
    name,
    label,
    value
  }) => {
    return isPresent(name) && name.match(searchRegex) || label.match(searchRegex) || value.match(searchRegex);
  });
}
let SendDeviceCodeModal = (_dec = readOnly('modalOptions.sendDeviceCode'), _dec2 = readOnly('modalOptions.description'), _dec3 = readOnly('modalOptions.location'), _dec4 = computed('modalOptions.employees.@each.canBeManaged', 'employeeInfo.permissions.canEmployeeDashboardManageEmployees'), _dec5 = notEmpty('employees'), _dec6 = filterBy('employees', 'email'), _dec7 = computed('userInfo', 'employeesWithEmail.[]'), _dec8 = computed('allEmployeeEmailOptions', 'selectedEmailOption.value'), _dec9 = computed('hasSearchableOptions', 'emailValue', 'selectedEmailOption.value'), _dec10 = filterBy('employees', 'phoneNumber'), _dec11 = computed('userInfo', 'employeesWithPhone.[]', 'formatter'), _dec12 = computed('allEmployeePhoneOptions', 'selectedPhoneOption.value'), _dec13 = computed('hasSearchableOptions', 'phoneValue', 'selectedPhoneOption.value'), _dec14 = computed('i18n'), _dec15 = equal('sendCodeTo', OPTIONS.EMAIL), _dec16 = equal('sendCodeTo', OPTIONS.PHONE), _class = class SendDeviceCodeModal extends Component.extend(Validations) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flash", _descriptor, this);
    _initializerDefineProperty(this, "i18n", _descriptor2, this);
    _initializerDefineProperty(this, "formatter", _descriptor3, this);
    _initializerDefineProperty(this, "employeeInfo", _descriptor4, this);
    _initializerDefineProperty(this, "userInfo", _descriptor5, this);
    _initializerDefineProperty(this, "sendDeviceCode", _descriptor6, this);
    _initializerDefineProperty(this, "description", _descriptor7, this);
    _initializerDefineProperty(this, "location", _descriptor8, this);
    /*
      Only use the searchable input if employees is not empty,
      otherwise render a regular input.
    */
    _initializerDefineProperty(this, "hasSearchableOptions", _descriptor9, this);
    _initializerDefineProperty(this, "employeesWithEmail", _descriptor10, this);
    _defineProperty(this, "selectedEmailOption", null);
    _defineProperty(this, "emailValue", null);
    _initializerDefineProperty(this, "employeesWithPhone", _descriptor11, this);
    _defineProperty(this, "selectedPhoneOption", null);
    _defineProperty(this, "phoneValue", null);
    _defineProperty(this, "sendCodeTo", OPTIONS.EMAIL);
    _initializerDefineProperty(this, "shouldSendEmail", _descriptor12, this);
    _initializerDefineProperty(this, "shouldSendPhone", _descriptor13, this);
  }
  /*
    Only list employees if the employee has permission to manage employees.
    Filter the employees by the ones that current employee can manage.
  */
  get employees() {
    if (!this.employeeInfo.permissions?.canEmployeeDashboardManageEmployees) {
      return [];
    }
    return this.modalOptions.employees.filterBy('canBeManaged');
  }
  get allEmployeeEmailOptions() {
    return this.employeesWithEmail.map(employee => {
      return {
        label: employee.email,
        value: employee.email,
        name: fullName(employee, this.userInfo)
      };
    });
  }
  get displayedEmployeeEmailOptions() {
    let displayedEmailOptions;
    if (!this.selectedEmailOption) {
      displayedEmailOptions = this.allEmployeeEmailOptions;
    } else {
      displayedEmailOptions = filterOptionsBy(this.allEmployeeEmailOptions, this.selectedEmailOption.value);
    }
    return displayedEmailOptions.sortBy('name');
  }
  get email() {
    if (this.hasSearchableOptions) {
      return this.get('selectedEmailOption.value'); // eslint-disable-line ember/no-get
    }
    return this.emailValue;
  }
  get allEmployeePhoneOptions() {
    return this.employeesWithPhone.map(employee => {
      return {
        label: this.formatter.phoneNumber(employee.phoneNumber),
        value: employee.phoneNumber,
        name: fullName(employee, this.userInfo)
      };
    });
  }
  get displayedEmployeePhoneOptions() {
    let displayedPhoneOptions;
    if (!this.selectedPhoneOption) {
      displayedPhoneOptions = this.allEmployeePhoneOptions;
    } else {
      displayedPhoneOptions = filterOptionsBy(this.allEmployeePhoneOptions, this.selectedPhoneOption.value);
    }
    return displayedPhoneOptions.sortBy('name');
  }
  get phone() {
    if (this.hasSearchableOptions) {
      return this.get('selectedPhoneOption.value'); // eslint-disable-line ember/no-get
    }
    return this.phoneValue;
  }
  get options() {
    return [{
      value: OPTIONS.EMAIL,
      label: this.i18n.t('common.email')
    }, {
      value: OPTIONS.PHONE,
      label: this.i18n.t('common.phone')
    }];
  }
  clearForm() {
    this.set('selectedPhoneOption', null);
    this.set('selectedEmailOption', null);
    this.set('phoneValue', null);
    this.set('emailValue', null);
  }
  send() {
    if (this.validations.isInvalid) {
      this.flash.showModalValidation(this.validations);
    } else {
      this.flash.clearModalValidation();
      const email = this.shouldSendEmail ? this.email : null;
      const phone = this.shouldSendPhone ? this.phone : null;
      this.sendDeviceCode(email, phone).then(() => this.close());
    }
  }
  sendCodeToChanged(value) {
    this.flash.clearModalValidation();
    this.set('sendCodeTo', value);

    // clear out the input after changing sendCodeTo option
    this.clearForm();
  }
  emailChanged(email) {
    this.set('selectedEmailOption', {
      label: email,
      value: email
    });
  }
  phoneChanged(phone) {
    this.set('selectedPhoneOption', {
      label: phone,
      value: phone
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "flash", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "employeeInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sendDeviceCode", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "location", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "employees", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "employees"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasSearchableOptions", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "employeesWithEmail", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "allEmployeeEmailOptions", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "allEmployeeEmailOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedEmployeeEmailOptions", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "displayedEmployeeEmailOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "email", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "email"), _class.prototype), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "employeesWithPhone", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "allEmployeePhoneOptions", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "allEmployeePhoneOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayedEmployeePhoneOptions", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "displayedEmployeePhoneOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phone", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "phone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "options", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "options"), _class.prototype), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "shouldSendEmail", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "shouldSendPhone", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "send", [action], Object.getOwnPropertyDescriptor(_class.prototype, "send"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendCodeToChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendCodeToChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emailChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "emailChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "phoneChanged"), _class.prototype), _class);
export { SendDeviceCodeModal as default };